// src/data/products/boysFashionAge2to6.ts

import { Product } from "../../../interfaces/common/girls_fashion";

export const boysFashionAge2to6: Product[] = [
    {
        id: 5_1,
        productId: 5_1,
        title: "PROMISE KID Dress for Boys | Full Sleeve Hoisery Cotton Printed Sweatshirt",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_one.png",
        badge: "",
        url: "https://amzn.to/45xVbqf"
    },
    {
        id: 5_2,
        productId: 5_2,
        title: "Pro-Ethic Style Developer Boy's Cotton Striped Kurta Pyjama",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_two.png",
        badge: "",
        url: "https://amzn.to/45AzyFO"
    },
    {
        id: 5_3,
        productId: 5_3,
        title: "Pro-Ethic Style Developer Kids Wear 3 Piece Suit Set for Boys",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_three.png",
        badge: "",
        url: "https://amzn.to/4kQDd6W"
    },
    {
        id: 5_4,
        productId: 5_4,
        title: "KYDA KIDS® 100% Pure Cotton Boy's Premium Printed Tshirt and Shorts",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_four.png",
        badge: "",
        url: "https://amzn.to/403ZRAH"
    },
    {
        id: 5_5,
        productId: 5_5,
        title: "rendy Dukaan Sports Jersey/Tshirts And Shorts For Boys",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_five.png",
        badge: "",
        url: "https://amzn.to/44fXdJi"
    },
    {
        id: 5_6,
        productId: 5_6,
        title: "THE VIBES BOOK Trending kids & Boys and pant in Trending print",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_six.png",
        badge: "",
        url: "https://amzn.to/45tWDKb"
    },
    {
        id: 5_7,
        productId: 5_7,
        title: "Trampoline Kids Cotton Terry Loop Patch-Work Printed T-Shirt",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_seven.png",
        badge: "",
        url: "https://amzn.to/45tGgNH"
    },
    {
        id: 5_8,
        productId: 5_8,
        title: "minicult cotton Kids Coords Full Sleeve Tshirt and pant set ",
        image: "/images/boys_fashion/fashioAge2to6/2to6_id_eight.png",
        badge: "",
        url: "https://amzn.to/3T4MwUG"
    }
];
